<template>
  <complete-profile platform="portal"/>
</template>

<script>
import AccountCompleteProfile from '../../components/assemble-account/AccountCompleteProfile.vue';
import AccountCompleteProfileWithoutPasswordVue from '../../components/assemble-account/AccountCompleteProfileWithoutPassword.vue';

export default {
  name: 'CompleteProfile',
  components: {
    'complete-profile': process.env.VUE_APP_NATIONAL_ID === '20' ? AccountCompleteProfileWithoutPasswordVue : AccountCompleteProfile
  }
};
</script>

<style scoped lang="scss">
</style>
